import { defineStore } from 'pinia'

export interface IMessagingState {
  isOpen: boolean
  targetFamilyId: string | null
  targetMemberId: string | null
}

export const useMessagingStore = defineStore('messaging', {
  state: (): IMessagingState => ({
    isOpen: false,
    targetFamilyId: null,
    targetMemberId: null,
  }),
  actions: {
    openMessager() {
      this.isOpen = true
    },
    closeMessager() {
      this.isOpen = false
      this.targetFamilyId = null
      this.targetMemberId = null
    },
    toggleMessager() {
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        this.targetFamilyId = null
        this.targetMemberId = null
      }
    },
    openToMember(familyId: string, memberId: string) {
      this.targetFamilyId = familyId
      this.targetMemberId = memberId
      this.isOpen = true
    },
    clearTarget() {
      this.targetFamilyId = null
      this.targetMemberId = null
    },
  },
})
